import styled, { keyframes } from 'styled-components';

const scroll = keyframes`
  0% { transform: translateY(100%); }
  100% { transform: translateY(-100%); }
`;

export const Wrapper = styled.div`
  width: 100%;
  color: #ffffffaa;
  font-size: 13px;
  overflow: hidden;
  border-radius: 12px;
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.5);
  backdrop-filter: blur(4px);
  border-radius: 20px;
  transition: opacity 1s ease;
  /* Gradient mask for fade effect */
  opacity: 0;
  pointer-events: none;

  &.visible {
    opacity: 1;
    pointer-events: all;
  }
`;

export const ScrollText = styled.div`
  white-space: pre-wrap;
  line-height: 1.5;
  padding: 12px 15px 15px 20px;
  background: rgba(0, 0, 0, 0.4); // slightly less dark for a softer background
  text-shadow: 0 1px 3px rgba(0, 0, 0, 0.5); // soften the text shadow
  mask-image: linear-gradient(to top, transparent 0%, black 20%, black 80%, transparent 100%);
  -webkit-mask-image: linear-gradient(
    to top,
    transparent 0%,
    black 20%,
    black 80%,
    transparent 100%
  );
  max-height: 110px;
  overflow: auto;
  box-sizing: border-box;
  border-radius: 12px;
`;
